var cov_1d01rdpj8y = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Pagination/Item.tsx",
      hash = "f0c93c7a784a57a9a0f98d4035d9d83f63a0b4ff",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Pagination/Item.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 21
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 16
        }
      },
      "2": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 50
        }
      },
      "3": {
        start: {
          line: 21,
          column: 30
        },
        end: {
          line: 21,
          column: 40
        }
      },
      "4": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 17
        }
      },
      "5": {
        start: {
          line: 26,
          column: 46
        },
        end: {
          line: 26,
          column: 56
        }
      },
      "6": {
        start: {
          line: 27,
          column: 22
        },
        end: {
          line: 27,
          column: 110
        }
      },
      "7": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 34,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 14,
            column: 37
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 16
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 11
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 25
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 87
          },
          end: {
            line: 27,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 87
          },
          end: {
            line: 27,
            column: 96
          }
        }, {
          start: {
            line: 27,
            column: 100
          },
          end: {
            line: 27,
            column: 109
          }
        }],
        line: 27
      },
      "1": {
        loc: {
          start: {
            line: 31,
            column: 41
          },
          end: {
            line: 31,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 41
          },
          end: {
            line: 31,
            column: 49
          }
        }, {
          start: {
            line: 31,
            column: 53
          },
          end: {
            line: 31,
            column: 62
          }
        }],
        line: 31
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Pagination/Item.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { getDirectionClass } from '../utils/classname';
import { paginationClass } from './styles';
var DefaultValue = (cov_1d01rdpj8y.s[0]++, {
  disabled: false,
  isCurrent: false
});

var Item =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Item, _PureComponent);

  var _super = _createSuper2(Item);

  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    cov_1d01rdpj8y.f[0]++;
    cov_1d01rdpj8y.s[1]++;
    _this = _super.call(this, props);
    cov_1d01rdpj8y.s[2]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Item, [{
    key: "handleClick",
    value: function handleClick() {
      cov_1d01rdpj8y.f[1]++;

      var _ref = (cov_1d01rdpj8y.s[3]++, this.props),
          page = _ref.page,
          onClick = _ref.onClick;

      cov_1d01rdpj8y.s[4]++;
      onClick(page);
    }
  }, {
    key: "render",
    value: function render() {
      cov_1d01rdpj8y.f[2]++;

      var _ref2 = (cov_1d01rdpj8y.s[5]++, this.props),
          children = _ref2.children,
          isCurrent = _ref2.isCurrent,
          disabled = _ref2.disabled;

      var className = (cov_1d01rdpj8y.s[6]++, paginationClass(getDirectionClass('item'), this.props.className, (cov_1d01rdpj8y.b[0][0]++, isCurrent) && (cov_1d01rdpj8y.b[0][1]++, 'current')));
      cov_1d01rdpj8y.s[7]++;
      return (
        /*#__PURE__*/
        // @ts-ignore
        React.createElement("a", {
          className: className,
          disabled: (cov_1d01rdpj8y.b[1][0]++, disabled) || (cov_1d01rdpj8y.b[1][1]++, isCurrent),
          onClick: this.handleClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 31,
            columnNumber: 7
          }
        }, children)
      );
    }
  }]);

  return Item;
}(PureComponent);

Item.defaultProps = DefaultValue;
export default Item;